<template>
  <v-row>
    <v-col cols="12">
      <v-tabs class="product-type-tab">
        <v-tab v-for="productType in productTypes" :key="productType.id"
               @change="changeProductType(productType)">
          <v-chip
            :label="true"
            x-small
            color="blue"
            text-color="white"
          >{{ productType.active_services }}</v-chip>
          {{ productType.type_name }}
        </v-tab>
      </v-tabs>
      <v-skeleton-loader
        v-if="!initiated"
        ref="skeleton"
        type="table"
        class="mx-auto"
      ></v-skeleton-loader>
      <v-row class="toolbar" dense v-if="initiated" >
        <v-col cols="12" md="6">
          <v-btn class="v-btn-more" small color="success" @click="gotoBuy()">
            Buy More</v-btn>
        </v-col>
        <v-col cols="8" md="4">
          <v-text-field
            class="search-input"
            hide-details
            prepend-icon="mdi-text-search"
            single-line
            v-model="search"
            @keyup.enter.native="loadTable()"
          ></v-text-field>
        </v-col>
        <v-col cols="4" md="2">
          <v-btn small color="primary" @click="loadTable()" class="v-btn-search">Search</v-btn>
        </v-col>
      </v-row>
      <v-data-table
        v-if="initiated"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1 service-list"
        :footer-props="{
          'items-per-page-options': [30,60,100,150,250],
        }"
      >
        <template v-slot:item.status_name="{ item }">
          <b v-if="item.status_name == 'Active'" class="green--text">{{ item.status_name }}</b>
          <b v-else class="red--text">{{ item.status_name }}</b>
        </template>
        <template v-slot:item.actions="{ item }">
          <div v-if="item.term_name !== 'One Time'">
            <v-btn
              x-small
              color="success"
              v-if="item.status_name === 'Active'
                  || item.status_name === 'Expired'"
              @click="manage(item)"
            >
              Manage
            </v-btn>&nbsp;&nbsp;
            <v-btn
              x-small
              color="success"
              v-if="hasAiLogin(item)
                && (item.status_name === 'Active')
                "
              :loading="loginLoading"
              :disabled="loginLoading"
              @click="login(item)"
            >
              Login AI Agent WebUI
            </v-btn>&nbsp;&nbsp;
            <v-btn
              x-small
              color="success"
              v-if="item.has_login
              && (item.status_name === 'Active'
                || item.status_name === 'Expired')
              "
              :loading="loginLoading"
              :disabled="loginLoading"
              @click="login(item)"
            >
              Login Cpanel
            </v-btn>
            <v-btn
              x-small
              color="error"
              v-if="item.has_login
                && (item.status_name === 'Active')
                && $store.state.user.friend_code === 'f6455772'
                "
              :loading="suspendLoading"
              :disabled="suspendLoading"
              @click="suspend(item)"
            >
              Suspend
            </v-btn>&nbsp;&nbsp;
            <v-btn
              x-small
              color="success"
              v-if="item.has_login
                && (item.status_name === 'Active (Client Suspend)')
                && $store.state.user.friend_code === 'f6455772'
                "
              :loading="suspendLoading"
              :disabled="suspendLoading"
              @click="unsuspend(item)"
            >
              Unsuspend
            </v-btn>
            <v-btn
              x-small
              color="primary"
              v-if="(!item.status_name.includes('Pending')
                && item.status_name !== 'Terminated'
                && item.status_name !== 'Cancelled'
              )"
              @click="openRenewDialog(item)"
            >
              Renew
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              x-small
              color="error"
              v-if="item.status_name.includes('Pending')
              && item.status_name !== 'Terminated'
              && item.status_name !== 'Cancelled'
            "
              @click="openCancelDialog(item)"
            >
              Cancel
            </v-btn>
          </div>
        </template>

        <template v-slot:item.auto_renew="{ item }">
          <v-switch
            v-if="item.status_name.includes('Active')"
            v-model="item.auto_renew"
            :loading="item.loading"
            :readonly="true"
            @click.stop="toggleAutoRenew(item)"
          ></v-switch>
        </template>
      </v-data-table>
    </v-col>
    <v-dialog
      v-model="renewDialog"
      width="1024"
    >
      <v-card>
        <v-card-text>
          <h1 class="text-center" v-if="renewalTerms.length === 0">Loading renewal terms ...</h1>
          <v-row v-else>
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Current Expiry"
                    :readonly="true"
                    v-model="renewItem.expiry_date"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-select label="Renewal Terms"
                            :items="renewalTerms"
                            v-model="renewalTerm"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="renewDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="renewCheckoutLoading"
            @click="renew()"
          >
            Checkout
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="resetPasswordDialog"
      width="1024">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    v-model="newPassword"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :error="resetPasswordError"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="resetPasswordDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="resetPasswordSaveLoading"
            @click="resetPassword()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cancelDialog"
      width="1024">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <h3>Your service will be immediately terminated. Please be careful!</h3>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="cancelDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="cancelLoading"
            @click="cancel()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="tagDialog"
      width="1024"
    >
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="tag" label="Tag:"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="tagDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="tagLoading"
            @click="updateTag()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <service-renew-dialog
      v-if="showServiceRenewDialog"
      v-on:close-dialog="showServiceRenewDialog = false"
      :service-id="serviceId"
    ></service-renew-dialog>
  </v-row>
</template>

<script>
import ServiceRenewDialog from '../../components/dialogs/ServiceRenewDialog.vue';

export default {
  name: 'List',
  components: {
    ServiceRenewDialog,
  },
  data() {
    return {
      search: '',
      initiated: false,
      productTypeId: null,
      productTypes: [],
      totalItems: 0,
      items: [],
      strange: false,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 30,
      },
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Name', value: 'service_name' },
        { text: 'Domain', value: 'service_identity' },
        { text: 'Status', value: 'status_name' },
        { text: 'Term', value: 'term_name' },
        // { text: 'Price', value: 'renewal_price' },
        { text: 'Creation Date', value: 'provision_date' },
        { text: 'Expiry', value: 'expiry_date' },
        { text: 'Auto Renew', value: 'auto_renew' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      loginLoading: false,
      cancelDialog: false,
      cancelItem: null,
      cancelLoading: false,
      renewDialog: false,
      renewItem: null,
      renewLoading: false,
      renewCheckoutLoading: false,
      renewalTerms: [],
      renewalTerm: null,
      resetPasswordDialog: false,
      resetPasswordItem: null,
      resetPasswordLoading: false,
      resetPasswordSaveLoading: false,
      resetPasswordError: false,
      newPassword: null,
      showPassword: false,
      downgradeDialog: false,
      downgradeItem: null,
      downgradeLoading: false,
      upgradeDialog: false,
      upgradeItem: null,
      upgradeLoading: false,
      upgrades: [],
      upgrade: null,
      upgradeLoaded: false,
      downgrades: [],
      downgrade: null,
      downgradeLoaded: false,
      tag: '',
      tagItem: null,
      tagDialog: false,
      tagLoading: false,
      showServiceTransferDialog: false,
      showServiceRenewDialog: false,
      showServiceUpgradeDialog: false,
      serviceId: '',
      serviceName: '',
      serviceIdentity: '',
    };
  },
  watch: {
    options: {
      handler() {
        if (this.initiated) {
          this.loadTable();
        }
      },
      deep: true,
    },
  },
  created() {
    this.$api.get('partner/product-type/menu').then((response) => {
      this.productTypes = response.data;
      if (response.data[0]) {
        this.productTypeId = response.data[0].id;
      } else {
        this.productTypeId = 0;
      }
      this.initiated = true;
      this.loadTable();
    });
  },
  methods: {
    changeProductType(productType) {
      this.productTypeId = productType.id;
      this.loadTable();
    },
    manage(item) {
      this.$router.push({ name: 'Retail.ServiceDetail', params: { id: item.id } });
    },
    login(item) {
      this.loginLoading = true;
      this.$api.post('partner/service/login', {
        id: item.id,
      }).then((response) => {
        window.open(response.data.data.url, '_blank');
      }).catch((error) => {
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        } else {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.message,
          });
        }
      }).finally(() => {
        this.loginLoading = false;
      });
    },
    suspend(item) {
      this.suspendLoading = true;
      this.$api.post('partner/service/suspend', {
        id: item.id,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: `Service ${item.service_identity} is suspended.`,
        });
      }).catch((error) => {
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        } else {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.message,
          });
        }
      }).finally(() => {
        this.suspendLoading = false;
      });
    },
    unsuspend(item) {
      this.suspendLoading = true;
      this.$api.post('partner/service/unsuspend', {
        id: item.id,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: `Service ${item.service_identity} is unsuspended.`,
        });
      }).catch((error) => {
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        } else {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.message,
          });
        }
      }).finally(() => {
        this.suspendLoading = false;
      });
    },
    openRenewDialog(item) {
      this.showServiceRenewDialog = true;
      this.serviceId = item.id;
    },
    openCancelDialog(item) {
      this.cancelDialog = true;
      this.cancelItem = item;
    },
    openDowngradeDialog(item) {
      this.downgrade = null;
      this.downgradeDialog = true;
      this.downgradeItem = item;
      this.downgradeLoaded = false;
      this.downgrades.splice(0, this.downgrades.length);
      this.$api.post('partner/service/get-downgrades', {
        id: item.id,
      }).then((response) => {
        response.data.forEach((downgrade, index) => {
          this.downgrades.push({
            text: `${downgrade.product_name} $${downgrade.product_price}`,
            value: downgrade,
          });

          if (index === 0) {
            this.downgrade = downgrade;
          }
        });
      }).finally(() => {
        this.downgradeLoaded = true;
      });
    },
    openUpgradeDialog(item) {
      this.showServiceUpgradeDialog = true;
      this.serviceId = item.id;
    },
    openResetPasswordDialog(item) {
      this.resetPasswordItem = item;
      this.resetPasswordDialog = true;
      this.newPassword = '';
    },
    toggleAutoRenew(touchedItem) {
      const foundItemIndex = this.items.findIndex((item) => item.id === touchedItem.id);
      if (foundItemIndex >= 0) {
        const r = window.confirm(`Are you sure to toggle the auto renew for ${this.items[foundItemIndex].service_identity}?`);
        if (r === true) {
          this.$set(this.items[foundItemIndex], 'loading', true);
          this.$api.post('partner/service/set-auto-renew', {
            id: this.items[foundItemIndex].id,
            auto_renew: this.items[foundItemIndex].auto_renew ? 0 : 1,
          }).then(() => {
            this.$set(this.items[foundItemIndex], 'auto_renew', !this.items[foundItemIndex].auto_renew);
            const successMessage = this.items[foundItemIndex].auto_renew ? 'on' : 'off';
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: `Auto renew is turned ${successMessage}.`,
            });
          }).catch((error) => {
            if (error.response) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.response.data.message || error.response.data,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
          }).finally(() => {
            this.$set(this.items[foundItemIndex], 'loading', false);
          });
        }
      }
    },
    loadTable() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;
      this.loading = true;
      this.$api.post('partner/service/list', {
        search: {
          '*': this.search,
        },
        current_page: page,
        per_page: itemsPerPage,
        product_type_id: this.productTypeId,
        order: `${sortBy}:${sortDesc}`,
      }).then((response) => {
        this.totalItems = response.data.total;
        this.items = response.data.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    edit(item) {
      this.$router.push({ name: 'Admin.ProductDetail', params: { id: item.id } });
    },
    renew() {
      this.renewCheckoutLoading = true;
      this.$api.post('partner/service/renew', {
        id: this.renewItem.id,
        product_term: this.renewalTerm,
      }).then((data) => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Your renewal request is successfully added to the shopping cart.',
        });
        this.renewDialog = false;
        this.$store.dispatch('syncShoppingCart', data.data);
        this.loadTable();
      }).catch((error) => {
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        } else {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.message,
          });
        }
      }).finally(() => {
        this.renewCheckoutLoading = false;
      });
    },
    resetPassword() {
      this.resetPasswordSaveLoading = true;
      this.$api.post('partner/service/reset-password', {
        id: this.resetPasswordItem.id,
        new_password: this.newPassword,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Your hosting password is reset successfully.',
        });
        this.resetPasswordDialog = false;
      }).catch((error) => {
        this.resetPasswordError = true;
        if (error.response) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response.data.message || error.response.data,
          });
        } else {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.message,
          });
        }
      }).finally(() => {
        this.resetPasswordSaveLoading = false;
      });
    },
    cancel() {
      this.cancelLoading = true;
      this.$api.delete(`partner/service/${this.cancelItem.id}`)
        .then(() => {
          this.cancelDialog = false;
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'success',
            message: 'You have successfully cancelled this service.',
          });
        })
        .catch(() => {
        })
        .finally(() => {
          this.cancelLoading = false;
          this.loadTable();
        });
    },
    processUpgrade() {
      this.upgradeLoading = true;
      this.$api.post('partner/service/upgrade', {
        id: this.upgradeItem.id,
        product_price_id: this.upgrade.product_price_id,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Your upgrade request is submitted successfully.',
        });
        this.upgradeDialog = false;
        this.loadTable();
      }).finally(() => {
        this.upgradeLoading = false;
      });
    },
    processDowngrade() {
      this.downgradeLoading = true;
      this.$api.post('partner/service/downgrade', {
        id: this.downgradeItem.id,
        product_price_id: this.downgrade.product_price_id,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Your downgrade request is submitted successfully.',
        });
        this.downgradeDialog = false;
        this.loadTable();
      }).finally(() => {
        this.downgradeLoading = false;
      });
    },
    openTagDialog(item) {
      this.tagDialog = true;
      this.tag = item.tag;
      this.tagItem = item;
    },
    updateTag() {
      this.tagLoading = true;
      this.$api.post('partner/service/update-tag', {
        id: this.tagItem.id,
        tag: this.tag,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Tag is updated successfully',
        });
        this.tagDialog = false;
        this.loadTable();
      }).finally(() => {
        this.tagLoading = false;
      });
    },
    gotoBuy() {
      this.$router.push({ name: 'Retail.ServiceRegister' })
        .catch(() => {
        });
    },
    hasAiLogin(item) {
      if (item.service_name.indexOf('AI Agent G-') === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style scoped>
  table td {
    font-size: 0.75rem !important;
  }

  .product-type-tab .v-tab {
    justify-content: flex-start;
  }

  .product-type-tab .v-chip {
    margin-right: 8px;
  }

  .service-list .v-btn {
    margin-right: 4px;
    margin-bottom: 4px;
  }

  .toolbar {
    margin-bottom: 8px;
  }

  .search-input {
    padding: 0 !important;
  }

  .v-btn-search {
    margin-top: 10px;
    margin-right: 4px;
  }

  .v-btn-more {
    margin-top: 10px;
  }
</style>
